/// <amd-module name="VSSUI/Toast" />
export { Toast } from "./Components/Toast/Toast";
export { IToast, IToastProps } from "VSSUI/Components/Toast/Toast.Props";
